import styled from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';
import Tooltip from '@material-ui/core/Tooltip';
import Text from 'components/base/Text';
import { Flex, Separator } from 'components/base/layout-components';
import StyledAvatar from 'components/StyledAvatar';
import { pluralize } from 'common/utils/utils';
import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import PeopleEffortTooltip from './PeopleEffortTooltip';
import PeopleEffortSummary from './PeopleEffortSummary';
import {
  PROJECTS,
  getContributorName,
  getOrderedPeopleEffort
} from '../services/projects.services';
import { LBButton } from '@linearb/buzz';

const MostActiveWrapper = styled(Flex)`
  margin-top: 0.8rem;
  margin-left: 2rem;
`;

const PeopleEffortExtendedColumn = ({
  projectConfig,
  project,
  peopleEffortAvg,
  uniquePeopleEffort,
  uniqueExcludedPeople,
  totalNumberOfPeople,
  selectedPeriod,
  isSingleIterationView,
  iterations,
  singleIteration,
  isFTECalculation
}) => {
  const numOfMostActiveUsers = 4;

  const activeUniquePeople = getOrderedPeopleEffort(uniquePeopleEffort);

  const peopleDataCell = (name, id, effort, idx) => {
    const contributorName = getContributorName(name);
    const isLast = numOfMostActiveUsers === parseInt(idx + 1);

    return (
      <Flex key={id}>
        <Flex direction='column' key={id}>
          <StyledAvatar
            size='2rem'
            avatar={{
              url: getContributorAvatarUrl({ id: id.replace(/\D/g, '') }),
              name: null
            }}
          />
          <Text
            pt={SPACES['x-small']}
            size='small'
            width='7rem'
            ellipsisAfter='7rem'
          >
            {contributorName}
          </Text>
          <Text
            pt={SPACES['x-x-small']}
            size='small'
            color={PROJECTS.SECONDARY_COLOR}
          >
            {pluralize(effort, 'iteration')}
          </Text>
        </Flex>
        {!isLast && (
          <Separator
            height='100%'
            margin='0 1rem'
            color={getColor('catskillWhite')}
          />
        )}
      </Flex>
    );
  };

  return (
    <>
      <PeopleEffortSummary
        projectConfig={projectConfig}
        project={project}
        isExtendedView={true}
      />
      <Flex direction='column' height='100%'>
        <Flex>
          <Text size='medium' pb={SPACES.small} ml='2rem'>
            Most Active
          </Text>
          <Separator
            color={getColor('catskillWhite')}
            height='1.5rem'
            margin='0 1rem'
          />
          <Tooltip
            interactive
            placement='bottom'
            title={
              <PeopleEffortTooltip
                peopleEffortAvg={peopleEffortAvg}
                totalNumberOfPeople={totalNumberOfPeople}
                uniquePeopleEffort={uniquePeopleEffort}
                uniqueExcludedPeople={uniqueExcludedPeople}
                projectConfig={projectConfig}
                project={project}
                selectedPeriod={selectedPeriod}
                isSingleIterationView={isSingleIterationView}
                iterationsLength={iterations.length}
                singleIteration={singleIteration}
                isFTECalculation={isFTECalculation}
              />
            }
          >
            <LBButton
              color={lightColorPalette.lbBrightBlue_100}
              variant='ghost'
            >
              View all
            </LBButton>
          </Tooltip>
        </Flex>
        <MostActiveWrapper>
          {activeUniquePeople
            .slice(0, numOfMostActiveUsers)
            .map(({ name, id, effort }, idx) => {
              return peopleDataCell(name, id, effort, idx);
            })}
        </MostActiveWrapper>
      </Flex>
    </>
  );
};

export default PeopleEffortExtendedColumn;
